// extracted by mini-css-extract-plugin
export default {"app":"App__app--X2cFCr","content":"App__content--OFhu1F"};